/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {PropulsionSnapshot} from '../propulsion-snapshot.model';
import {VehicleSnapshot} from '../vehicle-snapshot.model';

export class UnmatchedVehPropReport {
  unmatchedPropSnapshot: PropulsionSnapshot[];
  unmatchedVehSnapshot: VehicleSnapshot[];
}
